import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from 'yup';
import { useState, useRef, useMemo } from "react";
import { isFunction, uniqBy } from "lodash";
import {useDispatch, useSelector} from "react-redux";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { Col, Row } from 'react-bootstrap';
import { Button, IconButton, TextField, Grid, Chip, Box, FormGroup, FormControlLabel, Checkbox } from '@mui/material';
import { CloseIcon } from '@material-ui/data-grid';
//import { firestore } from '../../../../config/firebaseConfig';
import { toast } from 'react-toastify';
import { Form, FormikProvider, FieldArray, useFormik } from 'formik'
import useToggle from "../../../../shared/functions/useToggle"; 
import {purchaseCartList} from "../../../../redux/slices/purchaseCartList";

import { AddNewQuatityToBuy } from "../../../../redux/slices/purchaseCartList";

export default function NewQtyToBuy({QuantityToBuy, QuantityInPO,QuantityInShpping, callback = null, ...rest }) {
const last = QuantityToBuy
  const ref = useRef()
  const { open, handleOpen, handleClose } = useToggle()
  const CartId = useSelector((state) => state.purchaseCartListRef.cartId)
  // const po = QuantityInPO



  const [isLoading, setisloading] = useState(true) 
  const dispatch = useDispatch();
 
  const qtyFormat = /^[1-9]+/
  const formSchema = Yup.object().shape({
    QuantityToBuy: Yup.string().matches(qtyFormat, "La Quantité saisi est invalide").required("champs doit etre remplis"),
  });


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      QuantityToBuy: QuantityToBuy ?? 0,
    },
    validationSchema: formSchema,
    onSubmit: async (values, { setErrors, setSubmitting, resetForm }) => {
      var QuantityToBuy = values.QuantityToBuy
      try {
        console.log(last, QuantityToBuy)

        dispatch(AddNewQuatityToBuy(rest.ItemId, CartId, parseInt(QuantityToBuy),parseInt(last), () => {
          dispatch(purchaseCartList(CartId, null))
          isFunction(callback) && callback(rest.ItemId, CartId, QuantityToBuy, last)
        }))


        setSubmitting(false);
        toast.success("success")
        resetForm();
        handleClose();
      } catch (error) {
        alert('error');

        setSubmitting(false);
        toast.error("error");
        setErrors(error);
      }
    }
  })

  const {
    values,
    errors,
    touched,
    handleSubmit,
    getFieldProps,
  } = formik;



  return (
    <>
      <Box ref={ref}>
        <Chip
          label={QuantityToBuy || 0}
          onClick={handleOpen}
        />
        <Dialog open={open} anchorEl={ref.current} onClose={handleClose} maxWidth='sm' fullWidth >

          <DialogTitle>
            <Row>
              <Col className='col-auto text-truncate' style={{ display: 'grid', placeItems: 'center' }}>
                {"QUANTITY TO BUY"}
                <p style={{fontWeight:"bold"}}>{" PO: "+QuantityInPO}{" | Ship: "+QuantityInShpping}</p>
                
              </Col>
              <Col className='col-auto ml-auto'>
                <IconButton onClick={handleClose}>
                  <CloseIcon />
                </IconButton>
              </Col>
            </Row>
          </DialogTitle>
          <FormikProvider value={formik}>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <DialogContent className='pt-4'>
                <Grid container spacing={2} columns={16}>
                  <Grid item xs={8} >
                    <TextField
                      label="QuantityToBuy"
                      variant="outlined"

                      error={Boolean(touched.QuantityToBuy && errors.QuantityToBuy)}
                      helperText={touched.QuantityToBuy && errors.QuantityToBuy}
                      {...getFieldProps('QuantityToBuy')}
                    />
                  </Grid>

                </Grid>
              </DialogContent>

              <DialogActions>
                <Button variant="contained" color='warning' onClick={handleClose}>
                  Cancel
                </Button><br />
                <Button variant='contained' color='secondary' type="submit" setisloading={isLoading} >
                  Update Quantity
                </Button>
                <Button variant='contained' color='warning' style={{width:"auto",margin:"5px",fontSize:"12px",fontWeight:"bold"}}>
                  FOR VALIDATION
                </Button>
                <Button variant='contained' color='primary' style={{width:"auto",margin:"5px",fontSize:"12px",fontWeight:"bold"}}>
                  Save For Later
                </Button>
              </DialogActions>
              <DialogActions>
              <Button variant='contained' color='primary' style={{width:"auto",margin:"5px",fontSize:"12px",fontWeight:"bold"}}>
                  FICHE DE COMMANDE
                </Button>
              <Button variant='contained' color='primary' style={{width:"auto",margin:"5px",fontSize:"12px",fontWeight:"bold"}}>
                  TRES URGENT
                </Button>
              <Button variant='contained' color='primary' style={{width:"auto",margin:"5px",fontSize:"12px",fontWeight:"bold"}}>
                  MOINS URGENT
                </Button>
                <Button variant='contained' color='primary' style={{width:"auto",margin:"5px",fontSize:"12px",fontWeight:"bold"}}>
                  NORMAL
                </Button>
              </DialogActions>
              
            </Form>
          </FormikProvider>

        </Dialog>
      </Box>

    </>
  )
}

